// Hardcoded values from @atlassian/jira-servicedesk-insight-urls
const ASSETS_ROUTE_PREFIX = '/jira/servicedesk/assets';
export const createObjectDetailUrl = (objectId: string) =>
	`${ASSETS_ROUTE_PREFIX}/object/${objectId}`;
